<template>
  <div>
    <slot></slot>
    <p v-if="objectModelAction.linked_form_id">
      Fill
      <a :href="RouteHelper.path({route: Route.editForm, modelOrId: objectModelAction.linked_form_id})" class="btn-link">
        {{objectModelAction.linked_form_title}}
      </a>
    </p>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import actionBaseMixin from "../mixins/action-base-mixin";
  import {RouteHelper} from "~/helpers/routeHelper";
  import ObjectModelAction from "~/models/objectModelActions/objectModelAction";
  import {Route} from "~/enums/route";

  export default Vue.extend({
    mixins: [
      actionBaseMixin
    ],
    props: {
      objectModelAction: {
        type: Object as () => ObjectModelAction,
        default: null,
      },
    },
    data: function() {
      return {
        RouteHelper,
        Route: Route
      };
    },
  });
</script>